<template>
  <fieldset class="card">
    <div class="card-header">
      Exercise Habits
    </div>
    <div class="card-body">
      <div class="row form-group">
        <div class="col-md-5 text-md-right">
          <label for="assessment-exercise-frequency">
            How many <strong>times a week</strong> do you engage in a specific exercise activity?
          </label>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-exercise-frequency-0"
              v-model="exercise_weekly_frequency"
              name="assessment_exercise_frequency"
              type="radio"
              class="form-check-input"
              value="0"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-frequency-0"
            >
              0
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-exercise-frequency-1"
              v-model="exercise_weekly_frequency"
              name="assessment_exercise_frequency"
              type="radio"
              class="form-check-input"
              value="1"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-frequency-1"
            >
              1
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-exercise-frequency-2-3"
              v-model="exercise_weekly_frequency"
              name="assessment_exercise_frequency"
              type="radio"
              class="form-check-input"
              value="2-3"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-frequency-2-3"
            >
              2 or 3
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-exercise-frequency-4-5"
              v-model="exercise_weekly_frequency"
              name="assessment_exercise_frequency"
              type="radio"
              class="form-check-input"
              value="4-5"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-frequency-4-5"
            >
              4 or 5
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-exercise-frequency-6-7"
              v-model="exercise_weekly_frequency"
              name="assessment_exercise_frequency"
              type="radio"
              class="form-check-input"
              value="6-7"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-frequency-6-7"
            >
              6 or 7
            </label>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-5 text-md-right">
          <label for="assessment-average-duration">
            Based on your answer above, about how many <strong>minutes per week</strong> do you exercise?
          </label>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-average-duration-0"
              v-model="exercise_duration"
              name="assessment_average_duration"
              type="radio"
              class="form-check-input"
              value="0"
              required
            >
            <label
              class="form-check-label"
              for="assessment-average-duration-0"
            >
              0 minutes
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-average-duration-20"
              v-model="exercise_duration"
              name="assessment_average_duration"
              type="radio"
              class="form-check-input"
              value="20"
              required
            >
            <label
              class="form-check-label"
              for="assessment-average-duration-20"
            >
              20 minutes or less
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-average-duration-100"
              v-model="exercise_duration"
              name="assessment_average_duration"
              type="radio"
              class="form-check-input"
              value="100"
              required
            >
            <label
              class="form-check-label"
              for="assessment-average-duration-100"
            >
              Between 20 and 100 minutes (about 1 hour)
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-average-duration-150"
              v-model="exercise_duration"
              name="assessment_average_duration"
              type="radio"
              class="form-check-input"
              value="150"
              required
            >
            <label
              class="form-check-label"
              for="assessment-average-duration-150"
            >
              Between 100 and 150 minutes (about 1.5 to 2.2 hours)
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-average-duration-300"
              v-model="exercise_duration"
              name="assessment_average_duration"
              type="radio"
              class="form-check-input"
              value="300"
              required
            >
            <label
              class="form-check-label"
              for="assessment-average-duration-300"
            >
              Between 150 and 300 minutes (about 2.5 to 5 hours)
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-average-duration-500"
              v-model="exercise_duration"
              name="assessment_average_duration"
              type="radio"
              class="form-check-input"
              value="500"
              required
            >
            <label
              class="form-check-label"
              for="assessment-average-duration-500"
            >
              Between 300 and 500 minutes (about 5 to 8 hours)
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-average-duration-500-more"
              v-model="exercise_duration"
              name="assessment_average_duration"
              type="radio"
              class="form-check-input"
              value="500+"
              required
            >
            <label
              class="form-check-label"
              for="assessment-average-duration-500-more"
            >
              500 minutes or more (about 8+ hours)
            </label>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-5  text-md-right">
          <label>
            What kind of exercise person would you consider yourself? (Please see the descriptions in blue (“i”) so that you can select the most appropriate answer).
          </label>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-exercise-type-none"
              v-model="exercise_exercise_type"
              class="form-check-input"
              name="assessment_exercise_type"
              type="radio"
              value="none"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-type-none"
            >
              I do not exercise. <i
                v-tooltip:top="'Takes less than 1,000 steps per day. Has no formal type of exercise.'"
                class="fa fa-info-circle text-primary d-inline"
              />
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-exercise-type-light"
              v-model="exercise_exercise_type"
              class="form-check-input"
              name="assessment_exercise_type"
              type="radio"
              value="light"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-type-light"
            >
              Light <i
                v-tooltip:top="'Walks slowly for 15 minutes or less, walks less than 7,000 steps per day, uses a treadmill at a speed less than 3.0. Example activities: Walks the dog, gardens or plays ping pong for 15 to 20 minutes.'"
                class="fa fa-info-circle text-primary d-inline"
              />
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-exercise-type-moderate"
              v-model="exercise_exercise_type"
              class="form-check-input"
              name="assessment_exercise_type"
              type="radio"
              value="moderate"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-type-moderate"
            >
              Moderate <i
                v-tooltip:top="'Takes brisk walks for about 30 minutes, walks 7,000 to 10,000 steps per day, participates in moderate weight lifting and/or interval training for about 15 to 30 minutes, uses a treadmill at a speed between 3.0 and 5.0.'"
                class="fa fa-info-circle text-primary d-inline"
              />
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-exercise-type-very-active"
              v-model="exercise_exercise_type"
              class="form-check-input"
              name="assessment_exercise_type"
              type="radio"
              value="very-active"
              required
            >
            <label
              class="form-check-label"
              for="assessment-exercise-type-very-active"
            >
              Very Active <i
                v-tooltip:top="'Goes running 2 to 3 times per week (uses a treadmill at a speed over 5.0), lifts heavy weights, participates in intense interval training 2 to 3 times a week for more than 30 minutes, participates in some form of physical activity 6 to 7 days a week for 30 to 60 minutes each time, takes more than 10,000 steps per day.'"
                class="fa fa-info-circle text-primary d-inline"
              />
            </label>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-5 text-md-right">
          <label for="assessment-exercise_daily_steps">
            <strong>How many steps have you taken today?</strong>
          </label>
        </div>
        <div class="col-md-4 col-lg-3">
          <div class="input-group form-check">
            <input
              id="assessment-exercise_daily_steps"
              v-model="exercise_daily_steps"
              type="number"
              class="form-control"
              step="1"
              min="0"
              required
            >
            <div class="input-group-append">
              <div class="input-group-text">
                steps/day
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-5 text-md-right">
          <label for="assessment-steps_goaln">
            <strong>What is your daily step goal? <i
              v-tooltip:top="'The general daily recommendation is between 8,000 and 10,000 steps, but talk with your physician to know what is best for you. Renal patients will most likely differ.'"
              class="text-primary fa fa-info-circle"
            /></strong>
          </label>
        </div>
        <div class="col-md-4 col-lg-3">
          <div class="input-group form-check">
            <input
              id="assessment-steps_goal"
              v-model="exercise_daily_steps_goal"
              type="number"
              class="form-control"
              step="1"
              min="0"
              required
            >
            <div class="input-group-append">
              <div class="input-group-text">
                steps/day
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'GET_DATA_FIELD',
  mutationType: 'UPDATE_DATA_FIELD',
});

export default {
  computed: {
    ...mapFields('healthData', {
      'exercise_exercise_type': 'exercise.exercise_type',
      'exercise_daily_steps': 'exercise.daily_steps',
      'exercise_daily_steps_goal': 'exercise.daily_steps_goal',
      'exercise_duration': 'exercise.duration',
      'exercise_weekly_frequency': 'exercise.weekly_frequency',
    })
  }
}
</script>
